import { effect, Injectable } from '@angular/core';
import { NavSlimLinks } from '@com-delta-idp/mnx-sitewide-header-ui';
import {
  MultiCitySearchCache,
  RetrieveSearch
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { Observable, of } from 'rxjs';
import { catchError, take } from 'rxjs/operators';
import {
  MODIFY_BUTTON,
  TRIP_TYPES
} from '../../constants/navigation-links/navigation-linkts-constants';
import { HeaderSlimBaseService } from './header-slim-base.service';

@Injectable({
  providedIn: 'root'
})
export class HeaderSlimFacadeService extends HeaderSlimBaseService {
  constructor() {
    super();
    effect(
      () => {
        const update = this.navSlimService.updateShoppingSlimNavData();
        if (update) {
          this.navSlimDetails.update((current) => ({
            ...current,
            ...(update.dates && {
              dates: this.adapter.formatDates(update.dates)
            }),
            ...(update.origin && { origin: update.origin }),
            ...(update.destination && { destination: update.destination })
          }));
        }
      },
      { allowSignalWrites: true }
    );
  }

  init(): void {
    this.corpPartner = this.deepLinkService.initializeDeepLinkValues();
    this.bookingFlightsFacadeService.flightsWidget$.subscribe((aem) => {
      if (!aem) {
        return;
      }
      this.aem = aem;
      if (this.appConfig.onBrowser) {
        this.setRecentSearchHeader();
      }
    });
  }

  setRecentSearchHeader(): void {
    const tripType = this.getTripType();
    this.tripType.set(tripType);
    const isCookiePresent = this.isCookiePresent();

    if (this.processDeepLinkSlimNav()) {
      this.setDeepLinkSlimNav(tripType, isCookiePresent);
    } else {
      if (this.tripType() === TRIP_TYPES.MULTICITY) {
        (this.processSlimNav(tripType) as Observable<MultiCitySearchCache>)
          .pipe(
            take(1),
            catchError(() => of(null))
          )
          .subscribe((response) => {
            if (response) {
              const navLinks = this.adapter.getContent(
                this.aem,
                response,
                this.tripType()
              );
              this.navSlimDetails.set(navLinks);
            } else {
              this.navSlimDetails.set({
                modifyButton: MODIFY_BUTTON
              } as NavSlimLinks);
            }
          });
      } else {
        (this.processSlimNav(this.tripType()) as Observable<RetrieveSearch[]>)
          .pipe(
            take(1),
            catchError(() => of(null))
          )
          .subscribe((response) => {
            if (response) {
              const navLinks = this.adapter.getContent(
                this.aem,
                response,
                this.tripType()
              );
              this.navSlimDetails.set(navLinks);
            } else {
              this.navSlimDetails.set({
                modifyButton: MODIFY_BUTTON
              } as NavSlimLinks);
            }
          });
      }
    }
  }

  setDeepLinkSlimNav(tripType: string, isCookiePresent: boolean): void {
    if (!this.checkToCallDeepLinkSlimNav()) {
      return;
    }

    if (isCookiePresent) {
      this.setDeepLinkSearch(undefined, tripType);
    } else {
      this.deepLinkService.handleDeepLinkWithoutCookie(tripType, (response) => {
        this.processDeepLinkResponse(response, tripType);
      });
    }
  }
}
